import { applicationConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (navigator.userAgent.indexOf('Trident/7.0') !== -1 || window.navigator.userAgent.indexOf('Edge') !== -1) {
  // browser unsupported
} else {
  bootstrapApplication(AppComponent, applicationConfig).catch((err) => console.log(err));
}
